import type { ServerSideLocaleMessages } from "@/composables/useServerSideLocales"
import type { Composer } from "vue-i18n"

type Translations = {
    [key: string]: {
        [locale: string]: string
    }
    [key: symbol]: never
    [key: number]: never
}

export function defineTranslations<T extends Translations>(translations: T, prefix?: string) {
    // useI18n will often break because it's very limited where it can be used, so we use the global i18n instance
    const i18n = (window as any).i18n.global as Composer<ServerSideLocaleMessages>
    const t = i18n.t

    return function (localKey: keyof T, params?: Record<string, unknown>) {
        if (!localKey || typeof localKey !== "string") {
            throw new Error("Invalid translation key")
        }

        const key = `${prefix}.${localKey}`
        const translated = t(key, params ?? {})

        // this should only happen when the developer hasn't updated translations yet, so for convenience we can just
        // use the translation from the definition instead as a fallback
        const locale = i18n.locale.value
        if (key === translated && translations[localKey][locale]) {
            return translations[localKey][locale] + "(!)"
        }

        return translated
    }
}
